import type { MouseEvent } from 'react';

import { useStripe } from '../context/StripeContext';
import useSubscriptionStatus from './useSubscriptionStatus';

export default function useTrainingAccess() {
  const { hasFullAppAccess, isValidating } = useSubscriptionStatus();
  const { setIsStripePayment } = useStripe();
  const isLocked = !isValidating && !hasFullAppAccess;

  const handleTrainingClick = (event: MouseEvent<HTMLElement>): void => {
    if (!isLocked) return;

    event.preventDefault();
    setIsStripePayment(true);
  };

  return { isLocked, handleTrainingClick };
}
